import React from 'react'
import {API_BASE_URL, PAYMENT_LIST_PAGE_SIZE} from '../../constants'
import axios from 'axios'
import Select from 'react-select';
import ReactTable  from "react-table";
import {getToken, setLocalKeyValue, getLocalKeyValue, getDateRange} from '../../storage'
import {DRN} from '../report/daterange'
import {Link } from 'react-router-dom'
import DateFormat from '../../utils/dateformat'
import {Currency} from '../../utils/currency'
import SearchInput from '../search/search'
import {updateHistory} from '../commons/functions'
export default class PaymentList extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      dateRange : getDateRange(),
      tableState: {},
      data: [],
      pages: null,
      loading: true,
      supplier: props.location.state ? (props.location.state.supplier || null): null,
    };
    this.fetchList = this.fetchList.bind(this)
    this.fetchData = this.fetchData.bind(this);
    this.deletePayment = this.deletePayment.bind(this)
    this.deleteFormat = this.deleteFormat.bind(this)
    this.goToAddPayment = this.goToAddPayment.bind(this)
    this.handleSearchInput = this.handleSearchInput.bind(this)
    document.title = "Payments List"
  }

  goToAddPayment(e) {
    e.preventDefault()
    this.props.history.push("/payments/create/")
  }

  handleSearchInput(q) {
    this.fetchData(this.state.tableState, {}, q)
  }

  downloadReport = (report_type) => {
    return   axios({
      url: report_type,
      method: 'get',
      responseType: 'blob',
      onDownloadProgress: progressEvent => {
        let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
        this.setState({downloadPercent:percentCompleted})
      },
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }



  downloadPayments = (xls_url) =>{
    this.setState({downloading_payments:true,})

    let apiurl = xls_url
    if(this.state.query) {
      apiurl = apiurl + "&q="+this.state.query
    }
    let dateRange = this.state.dateRange
    if(dateRange) {
      let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
      let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
      let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
      let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
      apiurl = apiurl + "&start_date="+start_date+"&end_date="+end_date
    }
    let supplier = this.state.supplier
    if(typeof supplier !== "undefined" && supplier !== null) {
      apiurl = apiurl + '&supplier_id='+supplier.id
    }

    this.downloadReport(apiurl).then((response)=> {
      this.setState({submitting_rate_sales:false})

      let disposition = response.headers['content-disposition']
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

    }).catch((err)=> {
      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

      }
    })
  }


    deletePayment(payment_id) {

      var confirmation = window.confirm('Are you sure about delete ?')

      if(confirmation) {
        axios({
          url: '/delete_payment/',
          baseURL: API_BASE_URL,
          method:'post',
          data: {id:payment_id},
          headers: {
            common: {
              'Authorization': 'Token ' + getToken()
            }
          }
        }).then(res => {
          this.fetchList()
        }).catch(err=>{
          console.log(err);
        })
      }
    }


    getSuppliers =(input) => {

      return   axios({
          url: '/list_suppliers/?q='+input,
          method: 'get',
          baseURL: API_BASE_URL,
          headers: {
            common: {
              'Authorization': 'Token ' + getToken()
            }
          }
        }).then((response)=> {
              return {options: response.data.suppliers}
        }).catch((err)=> {

          return Promise.resolve({ options: [] });
        })
    }

      handleSupplierChange =(value) =>{
        this.setState({supplier: value})
        this.fetchData(this.state.tableState, {}, this.state.query, this.state.dateRange, value)
        updateHistory(this.props, {supplier:value})
      }

      renderSupplierName(option){
        return <span>{option.name} {option.city}</span>
      }

    applyDateRange = (dateRange) => {
      this.fetchData(this.state.tableState, {}, this.state.query, dateRange)

    }

    fetchList(state=this.state.tableState, query=this.state.query, dateRange=this.state.dateRange, supplier=this.state.supplier) {

      this.setState({ loading: true });
      setLocalKeyValue(PAYMENT_LIST_PAGE_SIZE, state.pageSize)
      let apiurl = "/list_payments/?page=" + state.page + '&page_size='+state.pageSize;
      if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
          apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
          apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
      }

      if(query) {
        apiurl = apiurl + "&q="+query
      }
      if(dateRange) {
        let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
        let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
        let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
        let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
        apiurl = apiurl + "&start_date="+start_date+"&end_date="+end_date
      }
      if(typeof supplier !== "undefined" && supplier !== null) {
        apiurl = apiurl + '&supplier_id='+supplier.id
      }
      this.setState({tableState:state, query:query, dateRange:dateRange})
      axios({
        url: apiurl,
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.setState({
          data: res.data.payments,
          pages: res.data.pages,
          loading: false
        });
      });

    }

    fetchData(state, instance, query=this.state.query, dateRange=this.state.dateRange, supplier=this.state.supplier) {
      this.fetchList(state, query, dateRange, supplier)
    }

    deleteFormat(row) {
      return <button className="btn btn-sm btn-danger" onClick={e=>this.deletePayment(row.original.id)}>Delete</button>
    }

    supplierFormat(row) {
      let purchase = row.original.purchase
      if (typeof row.original.supplier !== "undefined" && row.original.supplier !== null) {

        return row.original.supplier.code ?  (row.original.supplier.code+" "+row.original.supplier.name) : row.original.supplier.name
      }
      else {
        return null
      }
    }

    purchaseFormat(row) {
      let purchase = row.original.purchase
      if(typeof purchase !== "undefined" && purchase !== null) {
        let bill_no
        if(purchase.supplier_bill_no && purchase.supplier_bill_no.length > 0) {
          bill_no = purchase.serial +" (" +purchase.supplier_bill_no+")"
        }
        else {
          bill_no = purchase.serial
        }
        return <Link to={"/purchases/edit/"+purchase.serial}>Purchase {bill_no}</Link>
      }

      else {
        return null
      }
    }


    render() {

      const { data, pages, loading } = this.state;
      let xls_url = "/export_payments_excel/?"
      const amountHeader = <div><Currency /> Amount</div>
      const columns = [
        {Header:'Date',  accessor:'date',sortable:true,  Cell:(row)=>(<DateFormat date={row.original.date}/>)},
        {Header:'Suppplier', accessor:'supplier.name', sortable:false, Cell:(row)=>{return this.supplierFormat(row)}},
        {Header:'Purchase', sortable:false, Cell:(row)=>{return this.purchaseFormat(row)}},

        {Header:amountHeader,  accessor:'amount',sortable:true, Cell:(row)=>(<div className="text-right">{row.original.amount}</div>)},
        {Header:'Mode', accessor: 'mode',sortable:false },
        {Header:'Reference', accessor: 'reference',sortable:false },
        {Header:'Notes', accessor: 'notes',sortable:false },
        {Header:'', Cell:(row)=>  {return this.deleteFormat(row)}}
      ]
      const defaultSort=[{id: "date", desc: true}]

      let pageSize = getLocalKeyValue(PAYMENT_LIST_PAGE_SIZE)

      if(typeof pageSize === "undefined"){
        pageSize = 20
      }
      else {
        pageSize = parseInt(pageSize, 10)
      }

      return <div>

      <section className="medium">

      <div className="row">
        <div className="col-sm-3">
        <Link to="/payments/create" className="btn btn-primary">Add New Payment</Link>
        </div>
        <div className="col-sm-3 mtop">
          <SearchInput handleSearchInput={this.handleSearchInput} placeholder={"Search Purchases"} />
        </div>
        <div className="col-sm-3 col-lg-2 col-lg-offset-1">
          <Select.Async multi={false} onChange={this.handleSupplierChange} valueRenderer={this.renderSupplierName}
          optionRenderer={this.renderSupplierName} value={this.state.supplier} valueKey="id" labelKey="name"
          loadOptions={this.getSuppliers} backspaceRemoves={true} placeholder="Select Supplier"/>

        </div>
        <div className="col-sm-3 col-lg-2 mtop col-lg-offset-1">
          <DRN applyDateRange={this.applyDateRange} dateRange={this.state.dateRange} />
        </div>
      </div>


      </section>

      <div className="row">
        <div className="col-sm-12">
          <div className="table-responsive">
            <div className="text-right"><button className="btn btn-default btn-sm" onClick={(e)=>{this.downloadPayments(xls_url)}}>Download xls</button></div>
            <ReactTable defaultSorted={defaultSort}
              noDataText="No Payments Found."

                columns={columns} manual data={data}
                pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={pageSize} />
          </div>

        </div>
      </div>

      </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/payment/paymentlist.js